import IdRequest from "@/entities/common/request/id_request"
import BaseLogic from "../base_logic"
import vuexStore from "@/store"
import Poster from "@/util/poster"
import RemoteResult from "@/entities/common/remote_result"
import RestPaths from "@/util/rest_paths"
import router from "@/router"
import RouteNames from "@/util/route_names"
import Formatter from "../formatter"
import ReservierungPending from "@/entities/common/reservierung_pending"

export default class BestaetigenReservierungNeuLogic extends BaseLogic {
  reservierung: ReservierungPending = null
  reservierungAufgeben: boolean = false
  bestaetigenWorking: boolean = false
  bestaetigenError: boolean = false

  init() {
    this.mainLogic.reservierungPendingListeners.push(() => {
      this.reservierung = this.mainLogic.reservierungPending
    })
    this.reservierung = this.mainLogic.reservierungPending
  }

  get datumUhrzeit(): string {
    return (
      Formatter.formatiereDatumUhrzeit(this.reservierung.zeitVon) +
      " - " +
      Formatter.formatiereDatumUhrzeit(this.reservierung.zeitBis)
    )
  }

  get personen(): string {
    return this.reservierung.personen.toString()
  }

  get kundeBezeichnung(): string {
    return (
      this.reservierung.kundeVorname + " " + this.reservierung.kundeNachname
    )
  }

  reservierungBestaetigen() {
    this.bestaetigenWorking = true
    this.bestaetigenError = false

    var request = new IdRequest()
    request.id = vuexStore.state.user.identifier

    Poster.postMember<RemoteResult<string>>(
      RestPaths.reservierungenPendingBestaetigen,
      request
    )
      .then((response) => {
        if (response.data.success) {
          router.push({ name: RouteNames.NEU.RESERVIERUNG_BESTAETIGT })

          this.reservierungAufgeben = true
          this.bestaetigenWorking = false
        } else {
          this.bestaetigenWorking = false
          this.bestaetigenError = true
        }
      })
      .catch(() => {
        this.bestaetigenWorking = false
        this.bestaetigenError = true
      })
  }
}
